import { render, staticRenderFns } from "./SelfService.vue?vue&type=template&id=44b6a260&scoped=true"
import script from "./SelfService.vue?vue&type=script&lang=js"
export * from "./SelfService.vue?vue&type=script&lang=js"
import style0 from "./SelfService.vue?vue&type=style&index=0&id=44b6a260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b6a260",
  null
  
)

export default component.exports